if (typeof window !== "undefined") {
  window.$hsOverlayCollection = window.$hsOverlayCollection || [];
}
